// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"ac2e1ced","453":"588f4db4","455":"c5a948c6","644":"8b55eb70"}[chunkId] + ".chunk.js";
};